const hidePopover = () => {
    const el = document.getElementById('hide-lmp-popover');

    if (el) {
        el.click();
    } else {
        document.querySelector('body')!.click();
    }
};

export default hidePopover;
